module.exports = __webpack_public_path__ + "static/media/POS_01_B.68b00a05.png";